export function specialCharacter(_char: string) {
  return _char
    .replace(/%/g, '%25') // 必须首先处理 % 字符，避免重复编码
    .replace(/\+/g, '%2B') // 使用全局替换和转义
    .replace(/ /g, '%20')
    .replace(/\//g, '%2F')
    .replace(/\?/g, '%3F')
    .replace(/#/g, '%23')
    .replace(/&/g, '%26')
    .replace(/=/g, '%3D');
}

export function specialCharacterDecode(_char: string) {
  return _char
    .replace(/%2B/g, '+')
    .replace(/%20/g, ' ')
    .replace(/%2F/g, '/')
    .replace(/%3F/g, '?')
    .replace(/%23/g, '#')
    .replace(/%26/g, '&')
    .replace(/%3D/g, '=')
    .replace(/%25/g, '%'); // 必须最后处理 % 字符，避免误解码其他已编码字符
}
